import React from 'react';
import DataTypes from '../../../components/Table/dataTypes';
import IconButton from '@material-ui/core/IconButton';
import CopyButton from 'components/nir/CopyButton';
import Tooltip from '@material-ui/core/Tooltip';
import { FormattedMessage } from 'react-intl';
import PreviewIcon from '@material-ui/icons/ImageSearch';

const formatFormulaCode = (formulaCode, version) => {
  return `${formulaCode.substring(0, 3)} ${formulaCode.substring(
    3,
    7
  )} ${formulaCode.substring(7, formulaCode.length)}\\${version}`;
};

const ppsiColumns = (marketLanguage, handleOpenModal, handleOpenPreview) => ({
  IfoodID: {
    name: 'ifoodID',
    label: 'iFood ID',
    calculateCellValue: data =>
      formatFormulaCode(
        data.formulaCode,
        data.referencedIFoodData.formulaVersion
      ),
    width: 150
  },
  PresentationName: {
    name: 'presentationName',
    dataField: `info.${marketLanguage}.presentationName`,
    label: 'Product Name',
    width: 550,
    grow: 4
  },
  PiaNumber: {
    name: 'piaNumber',
    dataField: `referencedIFoodData.piaArticleNumber`,
    label: 'PIA Number',
    width: 120
  },
  ActualPublishDate: {
    name: 'actualPublishDate',
    dataField: `actualPublishedDate`,
    dataType: DataTypes.Date,
    label: 'Publishing Date',
    searchable: false,
    width: 280
  },
  Version: {
    name: 'version',
    dataField: `version`,
    label: 'Version',
    width: 280
  },
  CopyGlobalPpsi: {
    name: 'copyGlobalPpsiToLocal',
    label: '',
    calculateCellValue: rowData => {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
          <CopyButton
            onClick={() => {
              handleOpenModal(
                rowData.ppsiId,
                rowData.id,
                rowData.referencedIFoodData.piaArticleNumber
              );
            }}
          >
            <FormattedMessage id="ppsi.copyInstruction" />
          </CopyButton>
          <Tooltip
            title={<FormattedMessage id="ppsi.previewInstructionTooltip" />}
          >
            <IconButton
              color="primary"
              size="medium"
              onClick={() =>
                handleOpenPreview(
                  {
                    ...rowData,
                    hideBackButton: true
                  },
                  marketLanguage
                )
              }
            >
              <PreviewIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      );
    },
    filterable: false,
    sortable: false,
    searchable: false,
    width: 240,
    grow: 0,
    shrink: 0
  }
});

export default ppsiColumns;
